import { observer } from 'mobx-react-lite'
import { Button, DropdownContent, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { type Tag } from 'entities/Tags/model/Tag'
import { TagsDropdownContentItems } from 'widgets/SearchDropdown/ui/DropdownContent/TagsDropdownContent/TagsDropdownContentItems'
import { type SearchDropdownTagsStore } from 'widgets/SearchDropdown/store/searchDropdownTagsStore'
import styles from './styles.module.scss'

type ITagsDropdownContentProps = {
  store: SearchDropdownTagsStore
  onChange?: (item: Tag) => void
  width?: number
}

export const TagsDropdownContent = observer(
  ({ store, onChange, width }: ITagsDropdownContentProps) => {
    const { init, search, maxLimit } = store

    const handleReset = () => {
      store.resetType()
      init()
    }

    return (
      <DropdownContent noPadding className={styles.wrap} width={width}>
        <div className={styles.searchWrap}>
          <TextField
            className={styles.search}
            variant='integrated'
            InputProps={{
              placeholder: 'Search tag',
            }}
            onChange={store.handleSearch}
            value={search}
            mainActions={[makeTextFieldAutoFocus({ withFocus: !search })]}
          />
        </div>
        {maxLimit && (
          <Typography
            variant='body-sm-medium'
            color='var(--content-primary-tertiary)'
            ariaLabel='TagsDropdownLimit'
            className={styles.limitInfo}
          >
            Select tags (up to {maxLimit})
          </Typography>
        )}

        <TagsDropdownContentItems store={store} onChange={onChange} />

        {store.hasSelectedItems && (
          <div className={styles.clear}>
            <Button typeBtn={'text'} text={'Clear'} onClick={handleReset} />
          </div>
        )}
      </DropdownContent>
    )
  }
)
